import styled from "styled-components"
import { theme } from "../../theme"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.colors.white};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  border-radius: 0.8rem;
  padding: 2rem;
  margin-bottom: 2rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`

export const Title = styled.div`
  ${(p) => p.theme.bold}
  font-size: 1.8rem;
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 40rem;

  ${(p) => p.theme.mQ.MEDIA_MAX_MEDIUM} {
    height: 30rem;
  }
`

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40rem;
  font-size: 1.4rem;
  color: ${(p) => p.theme.colors.greyDark};
`

export const LoadingSkeleton = styled.div`
  width: 100%;
  height: 40rem;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  position: relative;

  ${(p) => p.theme.mQ.MEDIA_MAX_MEDIUM} {
    height: 30rem;
  }
`

export const SkeletonAreaPath = styled.svg`
  width: 100%;
  height: 100%;
  opacity: 0.3;

  .skeleton-gradient {
    animation: shimmer 2s ease-in-out infinite;
  }

  @keyframes shimmer {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.6;
    }
  }
`

export const SkeletonAxis = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 3rem;
  margin-top: 1rem;
`

export const SkeletonLabel = styled.div`
  width: 4rem;
  height: 1rem;
  background: ${(p) => p.theme.colors.greyLight};
  border-radius: 0.2rem;
  opacity: 0.3;
`

export const ChartWrapper = styled.div<{ $isLoading: boolean }>`
  opacity: ${(p) => (p.$isLoading ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
`

export const ChartTooltip = styled.div`
  background: ${theme.colors.white};
  border: 0.1rem solid ${theme.colors.greyLight};
  border-radius: 0.8rem;
  padding: 1rem;
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.1)
`

export const ChartLabel = styled.p`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
`

export const ChartValue = styled.p`
  margin: 0.5rem 0 0 0;
  font-size: 1.4rem;
  color: ${theme.colors.turquoiseDark};
`
